<!-- <h3><b>ยินดีต้อนรับเข้าสู่<br>บริการหาหมอออนไลน์</b></h3> -->
<form autocomplete="off" #registerForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate>
  <div class="uk-text-left">
    <h5 style="margin-bottom: 0.3rem;">กรอกข้อมูลของท่าน เพื่อยืนยันตัวตน</h5>
  </div>
  <div class="uk-background-cover" style="padding:15px 15px 0px 15px"
    [ngStyle]="{'background-image': 'url('+bg_image+')'}">
    <div>
      <label for="id-card" class="uk-form-label" style="color: white;">เลขที่บัตรประจำตัวประชาชน</label>
      <div class="uk-form-controls uk-position-relative">
        <input id="id-card" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุหมายเลขบัตรประชาชน"
          mask="0-0000-00000-00-0" autocomplete="off" name="idCard" #idCard="ngModel"
          [(ngModel)]="model().form.idcard.value" [ngClass]="addClass(registerForm,'idCard')"
          remoteValidator="validateIdCard" [validateFunction]="validateIdCard" debounce="0.1" required />

      </div>

    </div>

    <!-- <hr style="margin: 0;margin-bottom: 0.2rem;"> -->
    <!-- <div>
        <label for="mobile" class="uk-form-label" style="color: white;">หมายเลขโทรศัพท์มือถือ</label>
        <div class="uk-position-relative">
          <input id="mobile" class="uk-input uk-border-rounded uk-text-bold uk-text-large"
            style="background-color:transparent; border: none;color: white;" type="text"
            placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ" mask="00A-AAA-A000" name="mobile" #mobile="ngModel"
            [(ngModel)]="model.form.mobile.text" disabled />
        </div>
      </div> -->
  </div>
  <div class="uk-form-controls uk-position-relative uk-text-left">
    @if (idCard.errors) {
      <div class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
        [ngClass]="addClass(registerForm,'idCard','msg')">
        @if(idCard.errors.required) {
          <span>กรุณาระบุหมายเลขบัตรประชาชน</span>
        }
        @if(idCard.errors.validateIdCard) {
          <span>กรุณาระบุหมายเลขบัตรประชาชนให้ถูกต้อง</span>
        }
      </div>
    }
    @if (!registerForm.invalid && verifyIdentityInvalid()) {
      <div class="uk-text-danger uk-form-danger" tabindex="-1">
        <span>ไม่พบหมายเลขบัตรประชาชนของท่านในระบบ</span>
      </div>
    }
  </div>
  <!-- <div class="uk-padding-small"></div>
  <div class="uk-text-left uk-padding-small" style="background-color: #f8f8f8;" *ngIf="remarkText != ''">
    <small [innerHTML]="remarkText | sanitizeHtml"></small>
  </div> -->
  <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
    <button type="submit"
      class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
      [disabled]="registerForm.invalid" (click)="onSubmit()">ถัดไป
    </button>
  </div>
</form>